import { Howl } from "howler";

const loadSingleAudio = (name, src, onFileLoaded) => {
    return new Promise((resolve, reject) => {
        const sound = new Howl({
            src: [src],
            preload: true,
            html5: false,

            onload: () => {
                //console.log(`Audio geladen: ${name}`);

                onFileLoaded(name);
                resolve([name, sound]);
            },

            onloaderror: (soundId, error) => {
                console.error(
                    `Audio konnte nicht geladen werden: ${name}`,
                    {
                        soundId,
                        error
                    }
                );

                reject(
                    new Error(
                        `Audio konnte nicht geladen werden: ${name}`
                    )
                );
            }
        });
    });
};

export const loadAllAudio = async (
    audioFiles,
    onFileLoaded = () => {},
    parallelLoads = 4
) => {
    const entries = Object.entries(audioFiles);
    const loadedEntries = [];

    /*
     * Es werden nur vier Dateien gleichzeitig geladen und
     * dekodiert. Das entlastet ältere iPads deutlich.
     */
    for (
        let index = 0;
        index < entries.length;
        index += parallelLoads
    ) {
        const currentBatch = entries.slice(
            index,
            index + parallelLoads
        );

        const loadedBatch = await Promise.all(
            currentBatch.map(([name, src]) =>
                loadSingleAudio(
                    name,
                    src,
                    onFileLoaded
                )
            )
        );

        loadedEntries.push(...loadedBatch);
    }

    return Object.fromEntries(loadedEntries);
};